import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ErrorActions } from "../actions";
import { tap } from "rxjs";
import { BUTTON_TEXT, GLOBAL_MESSAGES } from "../../variables/strings";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({ providedIn: "root" })
export class ErrorEffects {
    private readonly actions$ = inject(Actions);
    private readonly snackBar = inject(MatSnackBar);

    handleHttpError$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(ErrorActions.otherError),
                tap(({ error }) =>
                    this.snackBar.open(
                        error.errors && error.errors.message
                            ? error.errors.message
                            : GLOBAL_MESSAGES.ERROR_HTTP,
                        BUTTON_TEXT.CLOSE,
                        {
                            duration: 5000,
                            panelClass: "error-snackbar",
                            verticalPosition: "top",
                        },
                    ),
                ),
            );
        },
        { dispatch: false },
    );
}
